import React from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const Spinner = (props) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '150px' }}>
      <CircularProgress />
    </Box>
  )
}

export default Spinner
